import auth from "../../components/auth";
import useMountEffect from "../../hooks/useMountEffect";
import env from "../../env";

const Login = () => {
  const appTitle = "Microgrid Assessment";
  const src = ""; // Define the src variable if needed
  const authLogin = new auth();
  useMountEffect(() => {
    localStorage.clear();
    authLogin.login();
    return () => {};
  }, []);

  return (
    <div>
      <se-loading loading="true"></se-loading>
      <se-authentication
        app-title={appTitle}
        version={env.REACT_APP_VERSION}
        image-url={src}
      ></se-authentication>
    </div>
  );
};

export default Login;
